import { Component, ViewEncapsulation } from '@angular/core';
import { SiteNavComponent } from '../site-nav/site-nav.component';

@Component({
  selector: 'lv-dashboard-header',
  templateUrl: 'dashboard-header.component.html',
  styleUrls: ['dashboard-header.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [SiteNavComponent]
})
export class DashboardHeaderComponent {}
